import { LanguageCodes } from 'js/locale/constants'
function localizeLink(
  path: `/${string}/?${string}`,
  currentLanguage: LanguageCodes,
)
function localizeLink(path: `/${string}/`, currentLanguage: LanguageCodes)
function localizeLink(path: `/`, currentLanguage: LanguageCodes)
function localizeLink(path: string, currentLanguage: LanguageCodes = 'en') {
  if (currentLanguage !== 'en') {
    return `/${currentLanguage}${path}`
  } else {
    return `${path}`
  }
}

export { localizeLink }
